import { Fragment } from "react";
import { Link } from "react-router-dom";
import { CustomPagination } from "@store/action/GlobalAction";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const Videos = (props) => {
  const { store, t, setCurrentPage, dispatch, getAllVideos, per_page } = props;
  const shareUrl = window.location.origin;
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getAllVideos({
        page: x.selected + 1,
        per_page: per_page,
        search: window.location.search,
      })
    );
  };
  const renderData = () => {
    if (store?.total > 0) {
      return store?.data?.map((item, i) => (
        <div className="mb-2" key={i}>
          <div className="video-card video-gape">
            <div className="video-img" style={{ height: "300px" }}>
              <video
                style={{ borderRadius: "15px" }}
                width="100%"
                height="100%"
                controls
                src={item.file_path}
              />
            </div>
            <div className="video-content">
              <Link to={`/Gallery/Video/${item.id}`}>
                <p>{item.file_name}</p>
              </Link>
            </div>
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <ul className="blog-icon">
                <li>
                  <FacebookShareButton
                    url={`${shareUrl}/Gallery/Video/${item.id}`}
                  >
                    <FacebookIcon size={30} round={true} />
                  </FacebookShareButton>
                </li>

                <li>
                  <TwitterShareButton
                    url={`${shareUrl}/Gallery/Video/${item.id}`}
                  >
                    <TwitterIcon size={30} round={true} />
                  </TwitterShareButton>
                </li>
                <li>
                  <WhatsappShareButton
                    url={`${shareUrl}/Gallery/Video/${item.id}`}
                  >
                    <WhatsappIcon size={30} round={true} />
                  </WhatsappShareButton>
                </li>
                <li>
                  <FacebookMessengerShareButton
                    url={`${shareUrl}/Gallery/Video/${item.id}`}
                  >
                    <FacebookMessengerIcon size={30} round={true} />
                  </FacebookMessengerShareButton>
                </li>
                <li>
                  <EmailShareButton
                    url={`${shareUrl}/Gallery/Video/${item.id}`}
                  >
                    <EmailIcon size={30} round={true} />
                  </EmailShareButton>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ));
    }
  };
  return (
    <div className="content-detached content-right">
      {store?.total > 0 ? (
        <Fragment>
          <div className="container">
            <div className="row row-cols-3">{renderData()}</div>
          </div>
          <div className="d-flex justify-content-center">
            {CustomPagination(store.total, 5, handlePageChange)}
          </div>
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center mt-2">
          <p>{t("No Results")}</p>
        </div>
      )}
    </div>
  );
};

export default Videos;
